<div class="prompt-container">
	<div class="prompt-content">
		<div class="text-section">
			<span class="text-title">{{ "tax_information_item_title" | translate }}</span>
			<span class="text-description">{{ "tax_information_item_subtitle" | translate }}</span>
		</div>
		<div class="prompt-button">
			<bp-button (click)="onOptionClick()" fluid size="small" variant="primary">{{
				"share_now" | translate
			}}</bp-button>
		</div>
	</div>
</div>
